import classNames from 'classnames';
import { useFormikContext } from 'formik';
import { Heading } from 'yoso';
import { EvolveValues } from '~/components/Evolve/Form/EvolveForm.hooks';
import { EvolveSticky } from '~/components/Evolve/Form/Sticky/EvolveSticky';
import { T } from '~/components/I18n';
import { useEvolution } from '../../Evolve.hooks';
import styles from './EvolveFormHero.module.scss';
import friends from './confettiFriends.png';
export type EvolveFormHeroProps = {
  className?: string;
};

export const EvolveFormHero = ({ className }: EvolveFormHeroProps) => {
  const {
    values: { tokenType = '' },
  } = useFormikContext<EvolveValues>();
  const {
    data: { evolvedGrowth },
  } = useEvolution(tokenType);

  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.header}>
        <Heading level={3} className={styles.title}>
          <T name="citizen_evolve_popup_title" options={[evolvedGrowth]} />
        </Heading>
        <p className={styles.description}>
          <T name="citizen_evolve_popup_desc" balance />
        </p>
      </div>
      <div className={styles.body}>
        <img
          className={styles.image}
          src={friends}
          alt={`${tokenType} evolve`}
          width={335}
          height={147}
        />
      </div>
      <div className={styles.footer}>
        <EvolveSticky />
      </div>
    </div>
  );
};
